import React, { useState } from "react";
import Table from "../../Common/Table";
import { getPath } from "../../../utils";
import BlankState from "../../Common/BlankState";
import CollapsedFields from "../../../constants/GigsSupport/CollapsedFields.json";
import ExpandedFields from "../../../constants/GigsSupport/ExpandedFields.json";
import Back from "sushiweb/Icons/all/Back";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";

const GigsSupportList = ({
  gigsSupportList,
  slotHistoryDetail,
  setSlotHistoryDetail,
}) => {
  const [slotHistoryDate, setSlotHistoryDate] = useState("");

  const handleRowClick = (slot_history, date) => {
    setSlotHistoryDate(date);
    setSlotHistoryDetail(slot_history);
  };

  const handleBackClick = () => {
    setSlotHistoryDetail([]);
  };

  const getFieldValue = (item, key) => {
    if (key === "date") {
      return (
        <span
          onClick={() => handleRowClick(item["slot_history"], item[key])}
          className="edit-options"
        >
          {item[key]}
        </span>
      );
    }
    return item[key];
  };

  return getPath(gigsSupportList, "length", undefined) > 0 ? (
    <>
      {slotHistoryDetail.length > 0 ? (
        <>
          <FlexContainer className="mb-20" justify="flex-start">
            <Back
              onClick={handleBackClick}
              className="mr-10 backBtn"
              color={variables.grey400}
            />
            <span className="medium">
              {" "}
              Slot History For: {slotHistoryDate}{" "}
            </span>
          </FlexContainer>
          <Table
            list={slotHistoryDetail}
            fields={ExpandedFields}
            getFieldValue={getFieldValue}
          />
        </>
      ) : (
        <Table
          list={gigsSupportList}
          fields={CollapsedFields}
          getFieldValue={getFieldValue}
        />
      )}
    </>
  ) : (
    <BlankState />
  );
};

export default GigsSupportList;
